import { action, makeObservable, observable } from 'mobx';
import { assertNever } from '@kofno/piper';
import { Maybe, nothing } from 'maybeasy';
import { deleteImage, error, loading, ready, UploadImageState } from './Types';
import { TPlainTextKey } from '../../../../../../../Translations';
import { FileMetaData } from '../S3ImageUpload/Types';

export class UploadImageStore {
  @observable
  state: UploadImageState;

  constructor() {
    makeObservable(this);
    this.state = ready(nothing());
  }

  @action
  ready = (fileMetaData: Maybe<FileMetaData>) => {
    switch (this.state.kind) {
      case 'loading':
        this.state = ready(fileMetaData);
        break;
      case 'error':
      case 'delete':
      case 'ready':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  loading = () => {
    switch (this.state.kind) {
      case 'error':
      case 'ready':
      case 'delete':
        this.state = loading();
        break;
      case 'loading':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  error = (message: TPlainTextKey) => {
    switch (this.state.kind) {
      case 'loading':
        this.state = error(message);
        break;
      case 'ready':
      case 'error':
      case 'delete':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  deleteImage = () => {
    switch (this.state.kind) {
      case 'error':
      case 'ready':
        this.state = deleteImage();
        break;
      case 'loading':
      case 'delete':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  reset = () => {
    this.state = ready(nothing());
  };
}
